import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { Config } from '../models/config';
import { ConfigDialogComponent } from './dialogs/config-dialog/config-dialog.component';
import { ConfigService } from '../services/config.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';

import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.scss'],
  entryComponents: [
    ConfigDialogComponent
  ]
})
export class ConfigComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = ['icon', 'name', 'id', 'format', 'edit', 'delete'];

  constructor(
    private _configService: ConfigService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _authService: AuthService,
    private router: Router
  ) {

    if (!this._authService.isAdmin) {
      this.router.navigate(['home']);
    }

    this.loadConfigs()
  }

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.sub)
      this.sub.unsubscribe();
  }

  loadConfigs() {

    this.sub = this._configService.select()
      .subscribe((result) => {
        let array = result.map(item => {
          let entity = new Config();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.format = item.payload.doc.data().format;
          entity.plain_text = item.payload.doc.data().plain_text;
          entity.plain_text_en = item.payload.doc.data().plain_text_en;
          entity.html_text = item.payload.doc.data().html_text;
          entity.html_text_en = item.payload.doc.data().html_text_en;
          return entity;
        });

        setTimeout(() => {
          this.dataSource = new MatTableDataSource(array);
          this.dataSource.sort = this.sort;
        });


      })

  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(entity) {

    let data: Config = new Config();

    if (entity) {
      data = entity;
    }

    this.dialog.open(ConfigDialogComponent, {
      width: '800px',
      height: '620px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }


  delete(element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.name + "<br><br>Excluir este texto?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._configService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete room error: " + error.message) }
          )
      }
    })
  }

}

